// Replace your getCurrentUserId function:
export const getCurrentUserId = () => {
  return localStorage.getItem("userId"); // No more random generation
};

export const PENDING_VERIFICATION_EMAIL_KEY = "pendingVerificationEmail";

export const EMAIL_NOT_VERIFIED_CODE = "EMAIL_NOT_VERIFIED";

export const isEmailNotVerifiedError = (error: {
  code?: string;
} | null): boolean => error?.code === EMAIL_NOT_VERIFIED_CODE;

export const isAuthenticated = () => {
  const userId = localStorage.getItem("userId");
  const accessToken = localStorage.getItem("accessToken");
  const tokenExpiry = localStorage.getItem("tokenExpiry");

  if (!userId || !accessToken) return false;
  if (tokenExpiry && Date.now() > parseInt(tokenExpiry, 10)) return false;

  return true;
};

export const isEmailVerified = () => {
  // Hint from localStorage only — routing gates must use the server
  // (onboarding API / requireVerifiedUser), not this helper alone.
  try {
    const userData = localStorage.getItem("userData");
    if (!userData) return false;
    return Boolean(JSON.parse(userData).verified);
  } catch (_err) {
    return false;
  }
};

export const persistSession = ({
  user,
  accessToken,
  expiresIn,
}: {
  user: { userId: string; [key: string]: unknown };
  accessToken: string;
  expiresIn?: number;
}) => {
  localStorage.setItem("userId", user.userId);
  localStorage.setItem("userData", JSON.stringify(user));
  localStorage.setItem("accessToken", accessToken);
  if (typeof expiresIn === "number") {
    localStorage.setItem(
      "tokenExpiry",
      String(Date.now() + expiresIn * 1000),
    );
  }
};

export const getCurrentUser = () => {
  const userId = getCurrentUserId();
  const userData = localStorage.getItem("userData");

  if (userData) {
    return JSON.parse(userData);
  }

  // Default user object
  return {
    id: userId,
    email: null,
    name: "Anonymous User",
    createdAt: new Date().toISOString(),
  };
};

export const updateUser = (userData) => {
  const currentUser = getCurrentUser();
  const updatedUser = { ...currentUser, ...userData };
  localStorage.setItem("userData", JSON.stringify(updatedUser));
  return updatedUser;
};

export const logout = () => {
  // Clear all authentication data
  localStorage.removeItem("userId");
  localStorage.removeItem("userData");
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("tokenExpiry");
  sessionStorage.removeItem(PENDING_VERIFICATION_EMAIL_KEY);

  // Clear session data
  sessionStorage.removeItem("oauth_state");
  sessionStorage.removeItem("oauth_provider");
  sessionStorage.removeItem("intended_route");

  console.log("User logged out, all data cleared");
};
